import { omit } from "lodash";
import { emptySplitApi } from "./empty-split-api";
import {
  AppointmentOutcomeReason,
  AppointmentOutcomeReasonInput,
  AppointmentOutcomeReasonResponse,
} from "./types/appointment-outcome-reasons.type";

export const appointmentOutcomeReasonsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getAppointmentOutcomeReasons: builder.query<
      AppointmentOutcomeReasonResponse,
      string
    >({
      query: (outcome) => `/appointment-outcome-reasons/?outcome=${outcome}`,
      providesTags: ["AppointmentOutcomeReasons"],
    }),
    getAllAppointmentOutcomeReasons: builder.query<
      AppointmentOutcomeReasonResponse,
      void
    >({
      query: () => `/appointment-outcome-reasons/`,
      providesTags: ["AppointmentOutcomeReasons"],
    }),
    getAppointmentOutcomeReason: builder.query<
      AppointmentOutcomeReason,
      number
    >({
      query: (appointmentOutcomeReasonId) =>
        `/appointment-outcome-reasons/${appointmentOutcomeReasonId}/`,
      providesTags: ["AppointmentOutcomeReasons"],
    }),
    addAppointmentOutcomeReason: builder.mutation<
      AppointmentOutcomeReason,
      AppointmentOutcomeReasonInput
    >({
      query: (appointmentOutcomeReason) => ({
        url: "/appointment-outcome-reasons/",
        method: "POST",
        body: appointmentOutcomeReason,
      }),
      invalidatesTags: ["AppointmentOutcomeReasons"],
    }),
    editAppointmentOutcomeReason: builder.mutation<
      AppointmentOutcomeReason,
      AppointmentOutcomeReasonInput
    >({
      query: (appointmentOutcomeReason) => ({
        url: `/appointment-outcome-reasons/${appointmentOutcomeReason.id}/`,
        method: "PATCH",
        body: omit(appointmentOutcomeReason, "id"),
      }),
      invalidatesTags: ["AppointmentOutcomeReasons"],
    }),
  }),
});

export const {
  useGetAppointmentOutcomeReasonsQuery,
  useGetAllAppointmentOutcomeReasonsQuery,
  useGetAppointmentOutcomeReasonQuery,
  useAddAppointmentOutcomeReasonMutation,
  useEditAppointmentOutcomeReasonMutation,
} = appointmentOutcomeReasonsApi;
